<template>
  <div>
    <div
      class="mapa"
      ref="mapa"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>
 
<script>
 
  import GoogleMapsApiLoader from "google-maps-api-loader";
 
  export default {
    props: {
      configMapa: Object,
      apiKey: String
    },
 
    data() {
      return {
        google: null,
        map: null
      };
    },
 
    async mounted() {
      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: this.apiKey
      });
      this.google = googleMapApi;
      this.initializeMap();
    },
 
    methods: {
      initializeMap() {
        const mapContainer = this.$refs.mapa;
        this.map = new this.google.maps.Map(mapContainer, this.configMapa);
        this.map.scrollwheel= true;
        this.map.zoom= 13;
        this.map.zoomControl= true;
        //this.map.fullscreenControl = false;
        this.map.rotateControl = true;
        this.map.mapTypeControl= false;
        this.map.streetViewControl= false;
        this.map.gestureHandling='greedy';
        this.map.setOptions({ minZoom: 14, maxZoom: 20 });
        var input = document.getElementById('searchTextField');
        var autocomplete = new this.google.maps.places.Autocomplete(input);
        this.google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                console.log(place.name);
            });
      }
    }
 
  };
</script>
 
<style scoped>
  .mapa {
    width: 100%;
    min-height: 100%;
  }
</style>